import QuizHeader from './QuizHeader';
export default QuizHeader;
